"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Authentication_1 = require("src/Authentication");
var Cookies_1 = require("src/Cookies");
var Env_1 = require("src/Env");
var FeatureFlags_1 = require("src/FeatureFlags");
var getFlagKey_1 = require("../../FeatureFlags/getFlagKey");
var EnvSettings_1 = require("./EnvSettings");
exports.CANARY_OPT_OUT_KEY = 'canary-opt-out';
/**
 * Loads rowan user status and canary opt out from stored cookies
 *
 * Responds to changes in Canary status by updating cookies and reloading the current page
 */
var ConnectedEnvSettings = /** @class */ (function (_super) {
    __extends(ConnectedEnvSettings, _super);
    function ConnectedEnvSettings() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isCanaryUser: false
        };
        /**
         * Update the env to the passed option
         */
        _this.onEnvClick = function (env) {
            console.info("ConnectedEnvironmentSettings: onEnvClick " + env);
            // set opt-out cookie for prod, remove in canary
            if (env === 'canary') {
                Cookies_1.default.remove(exports.CANARY_OPT_OUT_KEY);
            }
            else if (env === 'prod') {
                // add canary opt-out cookie for 10 hours
                var expireDate = new Date();
                expireDate.setHours(expireDate.getHours() + 10);
                Cookies_1.default.set(exports.CANARY_OPT_OUT_KEY, 'yes', expireDate);
            }
            // (local doesn't do anything)
            if (window.location.host.startsWith('rowan.local')) {
                window.location.reload();
                return;
            }
            var host = window.location.host
                .replace('canary-', '')
                .replace('stag-', '');
            if (env === 'stag') {
                host = "stag-" + host;
            }
            var path = window.location.pathname;
            var hash = window.location.hash;
            var location = "https://" + host + path + hash;
            console.info("ConnectedEnvironmentSettings location change: " + location);
            if (window.location.href === location) {
                window.location.reload();
            }
            else {
                window.location.assign(location);
            }
        };
        /**
         * Toggle feature flag value cookie
         */
        _this.onFeatureFlagClick = function (flag, enable) {
            console.info("ConnectedEnvironmentSettings: onFeatureFlagClick " + flag + " " + enable);
            var flagKey = getFlagKey_1.getFlagKey(flag);
            var expireDate = new Date();
            expireDate.setDate(expireDate.getDate() + 7);
            if (enable) {
                Cookies_1.default.set(flagKey, 'yes', expireDate);
            }
            else {
                Cookies_1.default.set(flagKey, 'no', expireDate);
            }
            _this.props.dispatch(FeatureFlags_1.singleFlagUpdated(flag, enable));
            window.location.reload();
        };
        return _this;
    }
    ConnectedEnvSettings.prototype.componentDidMount = function () {
        this.setState({
            isCanaryUser: Boolean(Authentication_1.AuthToken.getIsCanaryUser())
        });
    };
    ConnectedEnvSettings.prototype.render = function () {
        return (React.createElement(EnvSettings_1.default, { isCanaryUser: this.state.isCanaryUser, selectedEnv: Env_1.NAME, onEnvClick: this.onEnvClick, onFeatureFlagClick: this.onFeatureFlagClick, featureFlags: this.props.featureFlags }));
    };
    return ConnectedEnvSettings;
}(React.Component));
exports.default = react_redux_1.connect(function (state) { return ({
    featureFlags: state.featureFlags
}); }, function (dispatch) { return ({ dispatch: dispatch }); })(ConnectedEnvSettings);
